import * as React from "react";
import { withStyles } from "@material-ui/core";
import Dropzone from "react-dropzone";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import LandscapeIcon from "@material-ui/icons/Landscape";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import VideoIcon from "@material-ui/icons/Videocam";
import CloudUpload from "@material-ui/icons/CloudUpload";
import axios from "axios";
import { DubitoAPI } from "src/api/DubitoAPI";
import { DubitoSvc } from "src/api";
import * as classes from "src/api/classes";
import { openSnack } from "src/util/util";

const styleSheet = theme =>
  ({
    root: {
      flex: 1,
      padding: theme.spacing.unit,
      display: "flex",
      alignItems: "center",
      position: "relative"
    },
    button: {
      margin: theme.spacing.unit
    },
    dropzoneNormal: {
      display: "flex",
      flex: "1",
      height: 100,
      border: "2px dashed " + theme.palette.primary.light,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 12
    },
    dropzoneActive: {
      flex: "1",
      height: 100,
      border: "2px dashed " + theme.palette.grey.A200,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 12
    },
    dropzoneReject: {
      flex: "1",
      height: 100,
      border: "2px dashed " + theme.palette.error.dark,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 12
    },
    preview: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 48,
      alignSelf: "stretch",
      marginRight: theme.spacing.unit,
      borderWidth: "1px",
      borderColor: theme.palette.grey.A200,
      borderStyle: "solid",
      borderRadius: 12,
      overflow: "hidden",
      [theme.breakpoints.up("md")]: {
        width: 100
      }
    },
    previewImage: {
      width: 100,
      height: 100
    },
    progress: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%"
    }
  } as any);

class FileUpload extends React.Component<UploadProps, UploadState> {
  state = {
    file: undefined,
    progressValue: 0
  } as UploadState;

  onDrop = (accepted: File[], rejected: File[]) => {
    //console.log("files", accepted, rejected);
    this.setState({
      file: accepted[0]
    });
  };

  renderFileName() {
    if (this.props.selectedFile) {
      if (this.state.file) {
        return (
          <p>
            <b>{this.props.selectedFile}</b>{" "}
            {Math.round((this.state.file.size / 1024) * 10) / 10} kb{" "}
          </p>
        );
      }
      return (
        <p>
          <b>{this.props.selectedFile}</b>{" "}
        </p>
      );
    }
    if (this.state.file) {
      return (
        <p>
          <b>{this.state.file.name}</b>{" "}
          {Math.round((this.state.file.size / 1024) * 10) / 10} kb{" "}
        </p>
      );
    }
    return undefined;
  }

  renderPreview() {
    if (!this.state.file) {
      return <InsertDriveFileIcon />;
    } else if (
      this.state.file.preview &&
      this.state.file.preview.endsWith(".jpg")
    ) {
      if (this.state.file) {
        return (
          <img
            src={this.state.file.preview}
            className={this.props.classes.previewImage}
          />
        );
      }
      if (this.props.selectedFile) {
        return (
          <img
            src={this.props.selectedFile}
            className={this.props.classes.previewImage}
          />
        );
      }
      return <LandscapeIcon />;
    } else if (
      this.state.file.preview &&
      this.state.file.preview.endsWith(".mp3")
    ) {
      if (this.state.file) {
        return (
          <audio controls>
            <source src={this.state.file.preview} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      }
      if (this.props.selectedFile) {
        return (
          <audio controls>
            <source src={this.props.selectedFile} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      }
      return <AudiotrackIcon />;
    } else if (
      this.state.file.preview &&
      this.state.file.preview.endsWith(".mp4")
    ) {
      return <VideoIcon />;
    }
    return <InsertDriveFileIcon />;
  }

  uploadFile = async () => {
    if (!this.state.file) {
      return;
    }
    //console.log("Upload File:", this.state.file);
    const formData = new FormData();
    formData.append("file", this.state.file);
    //this.setState({ uploading: true });
    this.setState({ progressMode: "query", progressValue: 0 } as UploadState);
    axios
      .post(DubitoSvc.host + "/files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: DubitoSvc.getAuthHeader().get("Authorization")
        },
        onUploadProgress: progressEvent => {
          const percentCompleted =
            (progressEvent.loaded / progressEvent.total) * 100;
          this.setState({
            progressMode: "determinate",
            progressValue: percentCompleted
          } as UploadState);
          // this.setState({ uploadProgress: percentCompleted });
        }
      })
      .then((response: any) => {
        //console.log(response);
        this.setState({
          progressMode: undefined,
          progressValue: 0
        } as UploadState);
        this.props.onUploaded(response.data);
        this.setState({ file: undefined });
        // handle your response;
      })
      .catch(error => {
        // handle your error
      });
    /* const fm = { labels: this.props.labels } as any;
    fm.key =
      (this.props.folder ? this.props.folder + "/" : "") + this.state.file.name;

    this.setState({ progressMode: "query", progressValue: 0 } as UploadState);
    try {
      const { xhr, url } = await fileMan.upload(this.state.file, fm);
      xhr.onprogress = e => {
        console.log(
          e.lengthComputable,
          e.loaded,
          e.total,
          this.state.progressMode,
          this.state.progressValue
        );
        if (e.lengthComputable) {
          this.setState({
            progressMode: "determinate",
            progressValue: e.loaded / e.total
          } as UploadState);
        }
      };
      xhr.onreadystatechange = e => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          this.setState({
            progressMode: null,
            progressValue: 0
          } as UploadState);
          if (this.props.onChange) {
            if (xhr.status > 205) {
              console.error("failed to upload file");
              //   openSnack(`Upload failed`);
              return;
            }
            //   openSnack("Upload Completed");
            let u = url.split("?")[0];
            this.props.onChange(u);
          }
        }
      };
    } catch (err) {
      console.error(err);
      //  openSnack(`Upload failed: ${err}`);
    } */
  };

  render() {
    const classes = this.props.classes;
    return (
      <div className={classes.root}>
        <div className={classes.preview}>{this.renderPreview()}</div>
        <Dropzone
          onDrop={this.onDrop}
          accept={this.props.accept}
          className={classes.dropzoneNormal}
          activeClassName={classes.dropzoneActive}
          maxSize={20 * 1024 * 1024}
          rejectClassName={classes.dropzoneReject}
          onDropRejected={() => {
            openSnack("Maximum file size is 20MB", "error");
          }}
        >
          <div style={{ textAlign: "center" }}>
            <p>
              Drag a file here or <b>browse</b>
            </p>
            <span style={{ wordBreak: "break-all" }}>
              {this.renderFileName()}
            </span>
          </div>
        </Dropzone>
        <Button
          variant="fab"
          color="primary"
          className={classes.button}
          onClick={this.uploadFile}
          disabled={typeof this.state.file === "undefined"}
        >
          <CloudUpload />
        </Button>
        {this.state.progressMode && (
          <div className={classes.progress}>
            <LinearProgress
              variant={this.state.progressMode}
              value={this.state.progressValue}
            />
          </div>
        )}
      </div>
    );
  }
}

interface UploadProps {
  accept?: string;
  onChange?: (url: string) => void;
  selectedFile?: string;
  folder?: string;
  classes?: any;
  labels?: { [key: string]: string };
  onUploaded: (file: classes.File) => void;
}

interface UploadState {
  file: any;
  progressMode?: "determinate" | "indeterminate" | "buffer" | "query";
  progressValue: number;
}

export default withStyles(styleSheet)<UploadProps>(FileUpload as any);



// WEBPACK FOOTER //
// ./src/components/fileUpload.tsx